import type Reward from '@/interfaces/Reward'

export enum WindowStatus {
  Active = 'active', // current day
  Claimed = 'claimed', // past or current day, reward's claimed
  Future = 'future', // future day, locked
  Missed = 'missed', // past day, can be claimed for gems
}

export interface CalendarWindowType {
  adMultiplier: number
  order: number
  reward?: Reward
  status: WindowStatus
  videoWatched: boolean
}

export interface LoadCalendarResponse {
  currentWindow: number
  missedCost: number
  timeToNextDay?: number | null
  windows: CalendarWindowType[]
}

export interface OpenWindowResponse {
  reward: Reward
}
